import { Illustration } from '@wise/art';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import errorImageStyle from './ErrorImage.module.less';

const ErrorImage = ({ style }) => {
  const { formatMessage } = useIntl();
  return (
    <div className={`${style['m-b-5']} ${errorImageStyle['error-img-main']}`}>
      <Illustration
        loading="lazy"
        name="construction-fence"
        size="medium"
        alt={formatMessage({ id: 'error-image-alt-text' })}
      />
    </div>
  );
};

ErrorImage.propTypes = {
  style: PropTypes.shape({
    'm-b-5': PropTypes.string.isRequired,
    'img-responsive': PropTypes.string.isRequired,
  }).isRequired,
};

export default ErrorImage;
